// searchReducer.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    marketData: [],
    selectedItem: null,
    loading: false,
    dialogLoading: false,
    error: null,
    dialogOpen: false,
    isStreaming: false, 
    lastUpdated: null, 
};

const searchSlice = createSlice({
    name: 'search',
    initialState,
    reducers: {
         fetchMarketDataRequest: (state, action) => {
            state.loading = true;
            state.error = null;
        },

         fetchMarketDataSuccess: (state, action) => {
            state.loading = false;
            state.marketData = action.payload;
            
            state.error = null;
            state.lastUpdated = Date.now();
        },

         fetchMarketDataFailure: (state, action) => {
            state.loading = false;
            state.dialogLoading = false;
            state.error = action.payload;
            state.isStreaming = false;
        },

         setDialogLoading: (state, action) => {
            state.dialogLoading = action.payload;
        },

         selectItemAndOpenDialog: (state, action) => {
 
            if (!state.dialogOpen || state.selectedItem?.token !== action.payload?.token) {
                state.selectedItem = action.payload;
                state.dialogOpen = true;
                state.isStreaming = true;
            }
        },

         updateMarketDataLive: (state, action) => {
            state.marketData = action.payload;
            state.lastUpdated = Date.now();

             if (state.selectedItem && action.payload.length > 0) {
                const updatedItem = action.payload.find(
                    item => item.symbolToken === state.selectedItem.symbolToken
                );
                if (updatedItem) {
                    state.selectedItem = updatedItem;
                }
            }
        },

         closeDialog: (state) => {
            state.dialogOpen = false;
            state.selectedItem = null;
            state.dialogLoading = false;
            state.isStreaming = false;
        },

         clearMarketData: (state) => {
            state.marketData = [];
            state.selectedItem = null;
            state.dialogOpen = false;
            state.dialogLoading = false;
            state.isStreaming = false;
            state.lastUpdated = null;
        },

         stopMarketDataStream: (state) => {
            state.isStreaming = false;
        },

         resetError: (state) => {
            state.error = null;
        },
    },
});

export const {
    fetchMarketDataRequest,
    fetchMarketDataSuccess,
    fetchMarketDataFailure,
    setDialogLoading,
    selectItemAndOpenDialog,
    updateMarketDataLive,
    closeDialog,
    clearMarketData,
    stopMarketDataStream,
    resetError,
} = searchSlice.actions;

export default searchSlice.reducer;